import React from 'react';
import SourceModeEditor from './source-mode-editor';
import * as sourceModeDimensions from './source-mode-dimensions';
import ClickAwayListener from 'material-ui/internal/ClickAwayListener';

const MAX_Z_INDEX = 999999999;

const getMaskStyle = () => ({
  position: 'fixed',
  top: 0,
  left: 0,
  background: 'rgba(0, 0, 0, 0.5)',
  height: '100%',
  width: '100%',
  zIndex: MAX_Z_INDEX
});

const getContainerStyle = () => ({
  position: 'absolute',
  boxShadow: 'rgba(0, 0, 0, 0.5) 0px 0px 40px 10px',
  border: 'dashed 1px',
  zIndex: MAX_Z_INDEX,
  ...sourceModeDimensions.sourceModeDimensions()
});

const getFooterStyle = () => ({
  display: 'flex'
});

const getDoneButtonStyle = () => ({
  width: 'auto',
  padding: '0px 10px',
  marginTop: '5px'
});

class SourceModeContainer extends React.Component {
  constructor() {
    super();
    this.state = {
      containerStyle: getContainerStyle(),
      dragging: false
    };
    this.handleResize = this.handleResize.bind(this);
    this.onClickAway = this.onClickAway.bind(this);
    this.onMouseDownInEditor = this.onMouseDownInEditor.bind(this);
    this.onMouseUpInEditor = this.onMouseUpInEditor.bind(this);
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  onMouseDownInEditor() {
    this.setState({ dragging: true });
  }

  onMouseUpInEditor() {
    this.setState({ dragging: false });
  }

  onClickAway() {
    if (this.state.dragging === false) {
      this.props.onClose();
    } else {
      this.setState({ dragging: false });
    }
  }

  handleResize() {
    this.setState({ containerStyle: getContainerStyle() });
  }

  render() {
    return (
      <div className='source-mode-mask' style={getMaskStyle()}>
        <ClickAwayListener onClickAway={this.onClickAway}>
          <div style={this.state.containerStyle}>
            <SourceModeEditor
              onChange={this.props.onChange}
              htmlSource={this.props.htmlSource}
              onSave={this.props.onSave}
              onMouseDown={this.onMouseDownInEditor}
              onMouseUp={this.onMouseUpInEditor}
            />
            <footer style={getFooterStyle()}>
              <button
                type="button"
                style={getDoneButtonStyle()}
                className='source-code-button text-action-button'
                onClick={this.props.onClose}
              >
                Done
              </button>
            </footer>
          </div>
        </ClickAwayListener>
      </div>
    );
  }
}

SourceModeContainer.propTypes = {
  htmlSource: React.PropTypes.string,
  onChange: React.PropTypes.func,
  onClose: React.PropTypes.func,
  onSave: React.PropTypes.func
};

export default SourceModeContainer;



// WEBPACK FOOTER //
// ./src/ui/inline-text/source-mode-components/source-mode-container.jsx